module.exports = __webpack_public_path__ + "img/minus_btn.42794063.png";